import React from 'react'
import { Ico } from '@/components/icons'
import { useLang } from '@/lib/lang'

const ResetPasswordView = () => {
  const { t } = useLang()
  const r = t.acct.auth.reset

  return (
    <div style={{ height: "100%", background: "var(--paper)", display: "flex", alignItems: "center", justifyContent: "center", padding: 40 }}>
      <div style={{ width: 420 }}>
        <h2 className="font-display" style={{ fontSize: 40, fontWeight: 600, letterSpacing: "-0.03em", margin: "0 0 12px", lineHeight: 1.05 }}>
          {r.title} <span className="font-serif" style={{ color: "var(--terracotta)", fontWeight: 400 }}>{r.title_word}</span>
        </h2>
        <p style={{ fontSize: 15, color: "var(--muted)", margin: "0 0 28px", lineHeight: 1.55 }}>
          {r.blurb}
        </p>

        <div style={{ display: "grid", gap: 14, marginBottom: 18 }}>
          <div>
            <label className="auth-input-label">{r.new_password}</label>
            <div style={{ position: "relative" }}>
              <input className="auth-input" type="password" placeholder="At least 8 characters" style={{ paddingRight: 44 }}/>
              <span style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", color: "var(--muted)", cursor: "pointer" }}><Ico.eye/></span>
            </div>
          </div>
          <div>
            <label className="auth-input-label">{r.confirm_password}</label>
            <input className="auth-input" type="password" placeholder="Same password again"/>
          </div>
        </div>

        <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }}>
          {r.save_password} <Ico.arrow/>
        </button>

        <p style={{ fontSize: 12, color: "var(--muted)", marginTop: 18, textAlign: "center" }}>
          Link expires in 30 minutes · <a href="#" style={{ color: "var(--terracotta)" }}>Request a new one</a>
        </p>
      </div>
    </div>
  )
}

export default function ResetPasswordPage() {
  return <ResetPasswordView />
}
